// Joined rate plan codes on a meshed row are cut at this many characters.
export const RATE_PLAN_CODES_MAX_CHARS = 15;

const RATE_PLAN_CODES_SEPARATOR = ", ";

export const getMeshedLabel = (rowData) => {
  if (rowData?.meshed === true) return "Yes";
  if (rowData?.meshed === false) return "No";
  return "";
};

// Codes on a meshed row: every DR code plus the base code when the base rate
// plan priced a night, de-duplicated and sorted alphabetically.
export const getRatePlanCodes = (rowData) => {
  const codes = (rowData?.derivedRates || [])
    .map((derivedRate) => derivedRate?.drRateplanCode)
    .filter(Boolean);
  if (rowData?.includesBaseRatePlan && rowData?.ratePlanCode) {
    codes.push(rowData.ratePlanCode);
  }
  return [...new Set(codes)].sort((a, b) => a.localeCompare(b));
};

// Returns the joined codes cut at RATE_PLAN_CODES_MAX_CHARS and how many codes
// are not fully visible in that text (the "+N" chip).
export const getRatePlanCodesSummary = (codes) => {
  const joined = codes.join(RATE_PLAN_CODES_SEPARATOR);
  const isTruncated = joined.length > RATE_PLAN_CODES_MAX_CHARS;
  const text = isTruncated
    ? `${joined.slice(0, RATE_PLAN_CODES_MAX_CHARS)}…`
    : joined;

  let position = 0;
  let fullyVisible = 0;
  codes.forEach((code) => {
    if (position + code.length <= RATE_PLAN_CODES_MAX_CHARS) fullyVisible += 1;
    position += code.length + RATE_PLAN_CODES_SEPARATOR.length;
  });
  const hiddenCount = codes.length - Math.max(fullyVisible, 1);

  return { text, isTruncated, hiddenCount };
};

// Promotions on a row as { name, text }. Reads derivedRates when the search
// response carries it, otherwise the legacy top-level promotion fields.
export const getPromotions = (rowData) => {
  if (Array.isArray(rowData?.derivedRates)) {
    return rowData.derivedRates
      .filter((derivedRate) => derivedRate?.promotionName)
      .map((derivedRate) => ({
        name: derivedRate.promotionName,
        text: derivedRate.promotionText,
      }));
  }
  if (!rowData?.promotionName) return [];
  return [
    {
      name: rowData.promotionName,
      text: rowData.promotionDescription || rowData.promotionText,
    },
  ];
};
